import { HttpResponse } from '@angular/common/http';
import { throwError, TimeoutError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SessionTimerService } from './services/session-timer.service';
import { Globals } from './objects/Globals';
var HttpRequestInterceptor = /** @class */ (function () {
    function HttpRequestInterceptor(sessionTimerService, globals) {
        this.sessionTimerService = sessionTimerService;
        this.globals = globals;
    }
    HttpRequestInterceptor.prototype.intercept = function (request, next) {
        var _this = this;
        return next.handle(request).timeout(120000)
            .do(function (evt) {
            if (evt instanceof HttpResponse) {
                if (evt.url.indexOf("GetSummaryCard") > -1 || evt.url.indexOf("GetDetailCard") > -1 || evt.url.indexOf("HeaderCard") > -1) {
                    if (_this.globals.Session) {
                        _this.sessionTimerService.sessionTimerStatus.next(1);
                    }
                }
            }
        }) // 2 seconds
            .pipe(catchError(function (error) {
            // console.log(error);
            var errorMessage = '';
            if (error.error instanceof ErrorEvent) {
                // client-side error
                errorMessage = "Error: " + error.error.message;
            }
            else {
                // server-side error
                errorMessage = "Error Code: " + error.status + "\nMessage: " + error.message;
            }
            if (error instanceof TimeoutError) {
                return throwError('Timeout Exception');
            }
            return throwError(error); //it returns, handle it in service
        }));
    };
    return HttpRequestInterceptor;
}());
export { HttpRequestInterceptor };
